import z from 'zod';

// Validation pattern for input text fields (max 255 chars)
export const textPattern = /^[A-Za-z0-9 .&/:,()@#+!'\-]*$/;
export const textPatternMessage = 'Field can only contain English letters, numbers, and these characters: .&/:,()@#+!\'-';

// Validation pattern for TextArea fields (allows newlines, max 1000 chars)
export const textAreaPattern = /^[A-Za-z0-9 .&/:,()@#+!'\-\n\r]*$/;
export const textAreaPatternMessage = 'Field can only contain English letters, numbers, and these characters: .&/:,()@#+!\'-';

// Schema for required input fields (max 255 chars)
export const TextInputSchema = z.string()
  .min(1, 'This field is required')
  .max(255, 'Cannot exceed 255 characters')
  .regex(textPattern, textPatternMessage);

// Schema for optional input fields (max 255 chars)
export const TextInputOptionalSchema = z.string()
  .max(255, 'Cannot exceed 255 characters')
  .regex(textPattern, textPatternMessage)
  .optional();

// Schema for required TextArea fields (max 1000 chars)
export const TextAreaSchema = z.string()
  .min(1, 'This field is required')
  .max(1000, 'Cannot exceed 1000 characters')
  .regex(textAreaPattern, textAreaPatternMessage);

// Schema for optional TextArea fields (max 1000 chars)
export const TextAreaOptionalSchema = z.string()
  .max(1000, 'Cannot exceed 1000 characters')
  .regex(textAreaPattern, textAreaPatternMessage)
  .optional();

/**
 * Creates a required text input schema with custom error message
 * @param requiredMessage - Custom "required" error message
 * @param maxLength - Max character length (default 255)
 */
export const requiredTextField = (requiredMessage: string, maxLength: number = 255) => z.string()
  .min(1, requiredMessage)
  .max(maxLength, `Cannot exceed ${maxLength} characters`)
  .regex(textPattern, textPatternMessage);

/**
 * Creates an optional text input schema
 * @param maxLength - Max character length (default 255)
 */
export const optionalTextField = (maxLength: number = 255) => z.string()
  .max(maxLength, `Cannot exceed ${maxLength} characters`)
  .regex(textPattern, textPatternMessage)
  .optional();

/**
 * Creates a required textarea schema with custom error message
 * @param requiredMessage - Custom "required" error message
 * @param maxLength - Max character length (default 1000)
 */
export const requiredTextAreaField = (requiredMessage: string, maxLength: number = 1000) => z.string()
  .min(1, requiredMessage)
  .max(maxLength, `Cannot exceed ${maxLength} characters`)
  .regex(textAreaPattern, textAreaPatternMessage);

/**
 * Creates an optional textarea schema
 * @param maxLength - Max character length (default 1000)
 */
export const optionalTextAreaField = (maxLength: number = 1000) => z.string()
  .max(maxLength, `Cannot exceed ${maxLength} characters`)
  .regex(textAreaPattern, textAreaPatternMessage)
  .optional();